import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/homeworks/HomeworksAction";
import {
  downloadErrorAlert,
  redirectToPages,
  saveAsFile
} from "../../../../../_helpers/Helpers";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { StudentsPage } from "./students/StudentsPage";

export function HomeworkDetailPage({
  match: {
    params: { id }
  }
}) {
  // Getting curret state of Homeworks from store (Redux)
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, homework } = useSelector(
    (state) => ({
      actionsLoading: state.homeworks.actionsLoading,
      isSuccess: state.homeworks.isSuccess,
      type: state.homeworks.type,
      homework: state.homeworks.homework,
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getHomeworkDetail(id));
    return () => dispatch(actions.cleanHomeworkState());
  }, [dispatch, id]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  /** Belli Bir Eki İndirir */
  const downloadAttachment = () => {
    dispatch(actions.downloadAttachment(id)).then(file => {
      if (!file) {
        downloadErrorAlert();
        return;
      }
      saveAsFile(file, homework.attachmentName);
    });
  }

  return (
    <>
      <Card>
        { actionsLoading && <ModalProgressBar /> }
        <CardHeader title="Ödev Detayı" />
        <CardBody>
          <div className="form-group row">
            <div className="col-2">
              <b>Öğretmen:</b>
            </div>
            <div className="col-10">
              {homework.teacher}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Sınıf:</b>
            </div>
            <div className="col-10">
              {homework.section}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Ders:</b>
            </div>
            <div className="col-10">
              {homework.course}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Ödev Türü:</b>
            </div>
            <div className="col-10">
              {homework.homeworkTypeName}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Ödev Tanımı:</b>
            </div>
            <div className="col-10">
              {homework.definition}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Veriliş Tarihi:</b>
            </div>
            <div className="col-10">
              {homework.createDate}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2">
              <b>Son Tarih:</b>
            </div>
            <div className="col-10">
              {homework.lastDate}
            </div>
          </div>
          {
            homework.attachmentName &&
            <div className="form-group row">
              <div className="col-2">
                <b>Ek:</b>
              </div>
              <div className="col-10">
                <a href="javascript:" onClick={downloadAttachment}>{homework.attachmentName}</a>
              </div>
            </div>
          }
          <div className="form-group row">
            <div className="col-2">
              <b>Durum:</b>
            </div>
            <div className="col-10">
              {
                homework.isEvaluated !== undefined &&
                <span className={`label label-lg label-light-${homework.isEvaluated ? "success" : "danger"} label-inline`}>{homework.isEvaluated ? "Değerlendirildi" : "Değerlendirilmedi"}</span>
              }
            </div>
          </div>
          {
            homework.isEvaluated &&
            <div className="form-group row">
              <div className="col-2">
                <b>Değerlendirilme Tarihi:</b>
              </div>
              <div className="col-10">
                {homework.evaluationDate}
              </div>
            </div>
          }
        </CardBody>
      </Card>      
      <StudentsPage
        homeworkId={id}
        definition={homework.definition}
      />
    </>
  );
}